import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useSendMessageRequestMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.sendMessageRequest(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.messageRequests() });
		}
	});
};
//#endregion
export { i as useSendMessageRequestMutation };
